/**
 * One spelling of every in-app link (coherence review R07, wave W0).
 *
 * Author: Mahmoud Ragab Ahmed.
 *
 * The server's notifications and tasks carry short deep links (`/projects/:id`,
 * `/contracts/:id`, `/parties/:id`, `/verifications/:id`, `/action-requests/:id`). The
 * alias routes that used to render pages at those paths are retired; links already
 * stored in a notification still work because every consumer maps them here, and a
 * typed or bookmarked alias redirects through the same map.
 */

const PREFIXES: readonly (readonly [string, (rest: string) => string])[] = [
  ["/projects/", (rest) => `/portfolio/projects/${rest}`],
  ["/contracts/", (rest) => `/portfolio/contracts/${rest}`],
  ["/parties", () => "/portfolio/parties"],
  ["/verifications/", (rest) => `/inspections/${rest}`],
  ["/action-requests/", (rest) => `/actions/${rest}`],
];

/** The canonical route for a deep link; links already canonical pass through. */
export function canonicalPath(link: string): string {
  for (const [prefix, build] of PREFIXES) {
    if (link === prefix || link.startsWith(prefix)) {
      return build(link.slice(prefix.length));
    }
  }
  return link;
}
